(function () {
  var PLACEHOLDER = "[product_title]";

  function moneyFormat() {
    var settings = (window.themeVariables && window.themeVariables.settings) || {};
    var format = settings.currencyCodeEnabled ? settings.moneyWithCurrencyFormat : settings.moneyFormat;
    return String(format || "€{{amount}}").replace(/<[^>]*>/g, "");
  }

  function formatWithDelimiters(cents, precision, thousands, decimal) {
    var amount = (Number(cents) / 100).toFixed(precision);
    var parts = amount.split(".");
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    if (!precision) return whole;
    return whole + decimal + parts[1];
  }

  function formatMoney(cents) {
    var value = Number(cents);
    if (!Number.isFinite(value)) value = 0;
    var format = moneyFormat();
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var token = match ? match[1] : "amount";
    var formatted;

    switch (token) {
      case "amount_no_decimals":
        formatted = formatWithDelimiters(value, 0, ",", ".");
        break;
      case "amount_with_comma_separator":
        formatted = formatWithDelimiters(value, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        formatted = formatWithDelimiters(value, 0, ".", ",");
        break;
      case "amount_with_apostrophe_separator":
        formatted = formatWithDelimiters(value, 2, "'", ".");
        break;
      case "amount_no_decimals_with_space_separator":
        formatted = formatWithDelimiters(value, 0, " ", ".");
        break;
      case "amount_with_space_separator":
        formatted = formatWithDelimiters(value, 2, " ", ",");
        break;
      case "amount_with_period_and_space_separator":
        formatted = formatWithDelimiters(value, 2, " ", ".");
        break;
      default:
        formatted = formatWithDelimiters(value, 2, ",", ".");
    }

    return format.replace(/\{\{\s*\w+\s*\}\}/, formatted);
  }

  function productHandle(item) {
    if (item.handle) return item.handle;
    var url = item.url || "";
    var match = url.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : "";
  }

  function discountLabel(price, compare) {
    var raw = (1 - Number(price) / Number(compare)) * 100;
    if (!(raw > 0)) return "";
    var rounded = Math.round(raw * 10) / 10;
    var locale = document.documentElement.lang || "de";
    return "-" + new Intl.NumberFormat(locale, { maximumFractionDigits: 1 }).format(rounded) + " %";
  }

  var CartAddedModal = class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector("dialog");
      this.onVariantAdded = this.onVariantAdded.bind(this);
      this.onClick = this.onClick.bind(this);
      this.onDialogClick = this.onDialogClick.bind(this);
      this.onDialogClose = this.onDialogClose.bind(this);
      document.addEventListener("variant:add", this.onVariantAdded, true);
      this.addEventListener("click", this.onClick);
      this.dialog?.addEventListener("click", this.onDialogClick);
      this.dialog?.addEventListener("close", this.onDialogClose);

      var heading = this.querySelector("[data-complementary-heading]");
      this.complementaryTemplate = heading ? heading.textContent : "";

      if (window.Shopify && window.Shopify.designMode) {
        var section = this.closest(".shopify-section");
        this.onSectionSelect = function (event) {
          if (event.detail && event.detail.load) return;
          this.showPreview();
        }.bind(this);
        this.onSectionDeselect = this.close.bind(this);
        section?.addEventListener("shopify:section:select", this.onSectionSelect);
        section?.addEventListener("shopify:section:deselect", this.onSectionDeselect);
      }
    }

    disconnectedCallback() {
      document.removeEventListener("variant:add", this.onVariantAdded, true);
      this.removeEventListener("click", this.onClick);
      this.dialog?.removeEventListener("click", this.onDialogClick);
      this.dialog?.removeEventListener("close", this.onDialogClose);
      var section = this.closest(".shopify-section");
      if (section && this.onSectionSelect) {
        section.removeEventListener("shopify:section:select", this.onSectionSelect);
        section.removeEventListener("shopify:section:deselect", this.onSectionDeselect);
      }
      this.abort?.abort();
      if (this.dialog?.open) document.documentElement.classList.remove("lock");
    }

    onVariantAdded(event) {
      if (!event.detail || !event.detail.items || !event.detail.items.length) return;
      event.detail.blockCartDrawerOpening = true;
      var item = event.detail.items[0];
      var fromModal = event.target instanceof Element && event.target.closest("cart-added-modal") === this;
      this.fill(item, event.detail.cart || {});
      this.open();
      if (!fromModal) this.loadCrossSells(item);
    }

    fill(item, cart) {
      var quantity = item.quantity || 1;
      var variantTitle = item.variant_title && item.variant_title !== "Default Title" ? item.variant_title : "";
      var option = item.options_with_values && item.options_with_values[0];
      var variantLabel = option && option.value && option.value !== "Default Title" ? (option.name ? option.name + " " + option.value : option.value) : variantTitle;
      var productTitle = item.product_title || item.title || "";
      var title = this.querySelector("[data-success-title]");
      if (title) {
        var namePart = productTitle;
        if (variantLabel) namePart = namePart ? namePart + ", " + variantLabel : variantLabel;
        if (quantity > 1 && namePart) namePart = quantity + "× " + namePart;
        var added = this.dataset.added || "";
        title.textContent = (namePart + (added ? " " + added : "")).trim();
      }

      var stock = this.querySelector("[data-success-stock]");
      if (stock) {
        var live = document.getElementById("lieferzeit-info");
        var liveText = live && !this.contains(live) ? live.textContent.trim() : "";
        stock.textContent = liveText || this.dataset.inStock || "";
      }

      var productLink = this.querySelector("[data-product-title]");
      if (productLink) {
        productLink.textContent = productTitle;
        var handle = productHandle(item);
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
        productLink.href = handle ? root + "products/" + handle : item.url || "#";
      }

      var variant = this.querySelector("[data-product-variant]");
      if (variant) {
        variant.hidden = !variantTitle;
        variant.textContent = variantTitle;
      }

      var image = this.querySelector("[data-product-image]");
      var src = item.image || (item.featured_image && item.featured_image.url) || "";
      if (image) {
        if (src) {
          image.src = src.startsWith("//") ? "https:" + src : src;
          image.alt = productTitle;
          image.hidden = false;
        } else {
          image.hidden = true;
          image.removeAttribute("src");
        }
      }

      var price = item.final_price != null ? item.final_price : item.price;
      var original = item.original_price;
      this.renderPrice(this.querySelector("[data-price]"), {
        price: price,
        compare: original > price ? original : null
      });

      var subtotal = this.querySelector("[data-subtotal]");
      if (subtotal) {
        var cents = cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price;
        subtotal.textContent = formatMoney(cents || 0);
      }

      var heading = this.querySelector("[data-complementary-heading]");
      if (heading) {
        heading.textContent = (this.complementaryTemplate || "").split(PLACEHOLDER).join(productTitle);
      }

      this.enrichComparePrice(item);
    }

    renderPrice(container, prices) {
      if (!container) return;
      container.replaceChildren();
      var current = document.createElement("span");
      current.className = "cart-added-modal__price-current" + (prices.compare > prices.price ? " is-sale" : "");
      current.textContent = formatMoney(prices.price);
      container.append(current);

      if (!(prices.compare > prices.price)) return;

      var label = discountLabel(prices.price, prices.compare);
      if (label) {
        var off = document.createElement("span");
        off.className = "cart-added-modal__price-off";
        off.textContent = label;
        container.append(off);
      }

      var compare = document.createElement("s");
      compare.className = "cart-added-modal__price-compare";
      compare.textContent = formatMoney(prices.compare);
      container.append(compare);
    }

    enrichComparePrice(item) {
      var handle = productHandle(item);
      if (!handle) return;
      this.priceToken = (this.priceToken || 0) + 1;
      var token = this.priceToken;
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
      var variantId = String(item.variant_id || item.id);

      fetch(root + "products/" + encodeURIComponent(handle) + ".js")
        .then(function (response) {
          return response.ok ? response.json() : null;
        })
        .then(function (product) {
          if (!product || token !== this.priceToken) return;
          var variant = (product.variants || []).find(function (entry) {
            return String(entry.id) === variantId;
          });
          if (!variant || !(Number(variant.compare_at_price) > Number(variant.price))) return;
          this.renderPrice(this.querySelector("[data-price]"), {
            price: variant.price,
            compare: variant.compare_at_price
          });
          if (!this.querySelector("[data-product-image]")?.getAttribute("src") && product.featured_image) {
            var image = this.querySelector("[data-product-image]");
            image.src = product.featured_image;
            image.alt = product.title || "";
            image.hidden = false;
          }
        }.bind(this))
        .catch(function () {});
    }

    loadCrossSells(item) {
      if (!item.product_id) return;
      this.abort?.abort();
      this.abort = new AbortController();
      var signal = this.abort.signal;
      this.loadBlock("complementary", "complementary", item.product_id, signal);
      this.loadBlock("related", "related", item.product_id, signal);
    }

    loadBlock(name, intent, productId, signal) {
      var block = this.querySelector('[data-block="' + name + '"]');
      if (!block) return;
      var slot = block.querySelector("[data-slot]");
      var fallback = block.querySelector("[data-manual-fallback]");
      if (slot) slot.replaceChildren();
      if (fallback) fallback.hidden = true;
      block.hidden = true;

      this.fetchRecommendations(productId, intent, signal)
        .then(function (html) {
          if (signal.aborted) return;
          if (html && slot) {
            slot.innerHTML = html;
            block.hidden = false;
            this.updateScrollers(slot);
            return;
          }
          if (fallback && fallback.querySelector("[data-product-type]")) {
            fallback.hidden = false;
            block.hidden = false;
            this.updateScrollers(fallback);
            return;
          }
          block.hidden = true;
        }.bind(this))
        .catch(function (error) {
          if (error && error.name === "AbortError") return;
          if (fallback && fallback.querySelector("[data-product-type]")) {
            fallback.hidden = false;
            block.hidden = false;
            this.updateScrollers(fallback);
          }
        }.bind(this));
    }

    fetchRecommendations(productId, intent, signal) {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
      var limit = this.dataset.limit || "4";
      var url = root + "recommendations/products?product_id=" + encodeURIComponent(productId) + "&limit=" + encodeURIComponent(limit) + "&section_id=" + encodeURIComponent(this.dataset.sectionId || "") + "&intent=" + encodeURIComponent(intent);

      return fetch(url, { signal: signal }).then(function (response) {
        return response.ok ? response.text() : "";
      }).then(function (html) {
        if (!html) return "";
        var doc = new DOMParser().parseFromString(html, "text/html");
        var results = doc.querySelector("[data-recommendation-results]");
        return results ? results.innerHTML.trim() : "";
      });
    }

    applyFilter(button) {
      var cross = button.closest(".cart-added-modal__cross");
      if (!cross) return;
      var value = button.dataset.filter;
      cross.querySelectorAll("[data-filter]").forEach(function (filter) {
        var active = filter === button;
        filter.classList.toggle("is-active", active);
        filter.setAttribute("aria-pressed", active ? "true" : "false");
      });
      cross.querySelectorAll("[data-product-type]").forEach(function (card) {
        card.hidden = value !== "*" && card.dataset.productType !== value;
      });
      this.updateScrollers(cross);
    }

    scrollNext(button) {
      var scroller = button.closest("[data-scroller-wrap]")?.querySelector("[data-scroller]");
      if (!scroller) return;
      var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      scroller.scrollBy({
        left: Math.max(220, scroller.clientWidth * 0.8),
        behavior: reduce ? "auto" : "smooth"
      });
    }

    updateScrollers(root) {
      var scope = root || this;
      window.requestAnimationFrame(function () {
        scope.querySelectorAll("[data-scroller]").forEach(function (scroller) {
          var wrap = scroller.closest("[data-scroller-wrap]");
          var next = wrap?.querySelector("[data-scroll-next]");
          if (!next) return;
          next.hidden = scroller.scrollWidth <= scroller.clientWidth + 8;
        });
      });
    }

    onClick(event) {
      var filter = event.target.closest("[data-filter]");
      if (filter && this.contains(filter)) {
        event.preventDefault();
        this.applyFilter(filter);
        return;
      }

      var next = event.target.closest("[data-scroll-next]");
      if (next && this.contains(next)) {
        event.preventDefault();
        this.scrollNext(next);
        return;
      }

      if (event.target.closest("[data-cart-added-close]")) {
        event.preventDefault();
        this.close();
        return;
      }

      if (event.target.closest("[data-cart-added-open-cart]")) {
        event.preventDefault();
        this.openCart();
      }
    }

    onDialogClick(event) {
      if (event.target !== this.dialog) return;
      var rect = this.dialog.getBoundingClientRect();
      var inside = event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom;
      if (!inside) this.close();
    }

    onDialogClose() {
      document.documentElement.classList.remove("lock");
    }

    open() {
      if (!this.dialog) return;
      var drawer = document.querySelector("cart-drawer");
      if (drawer && drawer.open && typeof drawer.hide === "function") drawer.hide();
      if (!this.dialog.open) this.dialog.showModal();
      document.documentElement.classList.add("lock");
    }

    close() {
      this.dialog?.close();
    }

    openCart() {
      this.close();
      var drawer = document.querySelector("cart-drawer");
      var cartType = window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.cartType;
      if (drawer && cartType === "drawer" && typeof drawer.show === "function") {
        drawer.show();
        return;
      }
      window.location.href = this.dataset.cartUrl || "/cart";
    }

    showPreview() {
      this.fill({
        quantity: 1,
        product_title: this.dataset.previewProduct || "",
        title: this.dataset.previewProduct || "",
        variant_title: this.dataset.previewVariant || "",
        final_price: 1990,
        original_price: 2490,
        price: 1990,
        url: "#"
      }, { items_subtotal_price: 1990 });

      var complementary = this.querySelector('[data-block="complementary"]');
      var fallback = complementary?.querySelector("[data-manual-fallback]");
      if (complementary && fallback && fallback.querySelector("[data-product-type]")) {
        fallback.hidden = false;
        complementary.hidden = false;
        this.updateScrollers(fallback);
      }

      this.open();
    }
  };

  if (!window.customElements.get("cart-added-modal")) {
    window.customElements.define("cart-added-modal", CartAddedModal);
  }
})();
